import {
  EncryptionKey,
  EncryptionKeyType,
} from 'components/SubPages/ClaimInfo/features/greendotIntegration/useEncryptionKeys';

import encryptCardForGreenDot, {
  GreenDotEncryptedCard,
} from './encryptCardForGreenDot';
import encryptCardForTabapay from './encryptCardForTabapay';

type EncryptedCard = {
  name: string;
  key_id: string;
  encrypted_card: string | GreenDotEncryptedCard;
};

function encryptDebitCard(
  encryptionKeys: EncryptionKey[],
  cardNumber: string,
  expDate: string,
  cvv: string
): EncryptedCard[] {
  return encryptionKeys.map(key => {
    if (key.type === EncryptionKeyType.tabapay) {
      return {
        name: key.name,
        key_id: key.id,
        encrypted_card: encryptCardForTabapay(
          cardNumber,
          expDate,
          cvv,
          key.key
        ),
      };
    }

    if (key.type === EncryptionKeyType.greenDot) {
      return {
        name: key.name,
        key_id: key.id,
        encrypted_card: encryptCardForGreenDot(
          key.key,
          cardNumber,
          expDate,
          cvv
        ),
      };
    }
  });
}

export default encryptDebitCard;
